import React from 'react';
import { CardLegalStatus } from '@/components/CardLegalStatus/CardLegalStatus';
import { CardCountry } from '@/components/CardCountry/CardCountry';
import { CardSectionRate } from '@/components/CardSectionRate/CardSectionRate';
import type { RaportHSPLegalProps } from './RaportHSPLegal.types';
import { CardCountryI18n } from '@/components/CardCountry';

export const RaportHSPLegal: React.FC<RaportHSPLegalProps> = ({
  legalData,
  i18n,
}) => {
  // i18n fallbacks
  const overallStatusTitle = i18n?.overallStatusTitle || 'Status ogólny';
  const problematicStatusMessage =
    i18n?.problematicStatusMessage || 'Problematyczny';
  const { polishDatabases, countries } = legalData;

  return (
    <div className="mt-10 space-y-8">
      {/* Nagłówek sekcji */}

      {/* Blok oceny ogólnej */}
      <div className="max-w-full md:max-w-[400px]">
        <CardSectionRate
          rating={3}
          title={overallStatusTitle}
          variant="light"
          ratingMessage={problematicStatusMessage}
          verificationDate={legalData.verificationDate}
        />
      </div>

      {/* Sprawdzenia w polskich bazach */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {polishDatabases.map((database, index) => (
          <CardLegalStatus
            key={index}
            variant={database.variant}
            title={database.name}
            description={database.description}
            badgeText={database.badgeText}
          />
        ))}
      </div>

      {/* Sprawdzenia w bazach krajowych */}
      <div className="grid grid-cols-1 items-start justify-items-start gap-4 md:grid-cols-2 lg:gap-6 xl:grid-cols-3">
        {countries.map((country, index) => (
          <CardCountry
            key={index}
            country={country}
            status={country.status}
            recommendation={country.recommendation}
            i18n={
              {
                flagAltTemplate: i18n?.flagAltTemplate,
                recommendationLabel: i18n?.recommendationLabel,
                statusNotRecorded: i18n?.statusNotRecorded,
                statusRecorded: i18n?.statusRecorded,
                statusNoData: i18n?.statusNoData,
              } as CardCountryI18n
            }
          />
        ))}
      </div>
    </div>
  );
};
